"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var BookRequest;
(function (BookRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.description = undefined;
            _this.excerpt = undefined;
            _this.imgCoverUrl = undefined;
            _this.price = undefined;
            _this.finalPrice = undefined;
            _this.editorial = undefined;
            _this.author = undefined;
            _this.authorReview = undefined;
            _this.review = undefined;
            _this.format = undefined;
            _this.weight = undefined;
            _this.isActive = undefined;
            _this.highlightDate = undefined;
            _this.tags = undefined;
            _this.lastUpdateBIT = undefined;
            _this.lastPriceUpdateBIT = undefined;
            _this.createdAt = undefined;
            _this.stock = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    BookRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.description = undefined;
            _this.excerpt = undefined;
            _this.imgCoverUrl = undefined;
            _this.price = undefined;
            _this.finalPrice = undefined;
            _this.editorial = undefined;
            _this.author = undefined;
            _this.authorReview = undefined;
            _this.review = undefined;
            _this.format = undefined;
            _this.weight = undefined;
            _this.isActive = undefined;
            _this.highlightDate = undefined;
            _this.tags = undefined;
            _this.lastUpdateBIT = undefined;
            _this.lastPriceUpdateBIT = undefined;
            _this.stock = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    BookRequest.Update = Update;
    var Highlight = (function (_super) {
        __extends(Highlight, _super);
        function Highlight() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ids = undefined;
            return _this;
        }
        return Highlight;
    }(BaseModel_1["default"]));
    BookRequest.Highlight = Highlight;
})(BookRequest = exports.BookRequest || (exports.BookRequest = {}));
var BookResponse = (function () {
    function BookResponse() {
    }
    return BookResponse;
}());
exports.BookResponse = BookResponse;
(function (BookResponse) {
    var Book = (function (_super) {
        __extends(Book, _super);
        function Book() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.description = undefined;
            _this.excerpt = undefined;
            _this.imgCoverUrl = undefined;
            _this.price = undefined;
            _this.finalPrice = undefined;
            _this.editorial = undefined;
            _this.author = undefined;
            _this.authorReview = undefined;
            _this.review = undefined;
            _this.format = undefined;
            _this.weight = undefined;
            _this.isActive = undefined;
            _this.highlightDate = undefined;
            _this.tags = undefined;
            _this.promos = undefined;
            _this.lastUpdateBIT = undefined;
            _this.lastPriceUpdateBIT = undefined;
            _this.related = undefined;
            _this.createdAt = undefined;
            _this.stock = undefined;
            return _this;
        }
        return Book;
    }(BaseModel_1["default"]));
    BookResponse.Book = Book;
    var BookItem = (function (_super) {
        __extends(BookItem, _super);
        function BookItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.price = undefined;
            _this.imgCoverUrl = undefined;
            return _this;
        }
        return BookItem;
    }(BaseModel_1["default"]));
    BookResponse.BookItem = BookItem;
    var BookCarousel = (function (_super) {
        __extends(BookCarousel, _super);
        function BookCarousel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.author = undefined;
            _this.price = undefined;
            _this.finalPrice = undefined;
            _this.imgCoverUrl = undefined;
            _this.isActive = undefined;
            _this.stock = undefined;
            return _this;
        }
        return BookCarousel;
    }(BaseModel_1["default"]));
    BookResponse.BookCarousel = BookCarousel;
    var BookExcerpt = (function (_super) {
        __extends(BookExcerpt, _super);
        function BookExcerpt() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.author = undefined;
            _this.price = undefined;
            _this.finalPrice = undefined;
            _this.imgCoverUrl = undefined;
            _this.isActive = undefined;
            _this.hasStock = undefined;
            _this.stockWarning = undefined;
            _this.stock = undefined;
            _this.lastUpdateBIT = undefined;
            return _this;
        }
        return BookExcerpt;
    }(BaseModel_1["default"]));
    BookResponse.BookExcerpt = BookExcerpt;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.updated = false;
            _this.book = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    BookResponse.Update = Update;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects || [];
            _this.length = length || 0;
            _this.offset = offset || 0;
            _this.pagination = pagination || 100;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    BookResponse.All = All;
})(BookResponse || (BookResponse = {}));
exports.BookResponse = BookResponse;



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/book.js
// module id = ../model/dist/models/book.js
// module chunks = main